import React, { useState } from 'react';
import './FAQPage.css';

const FAQPage = () => {
  const [openQuestion, setOpenQuestion] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "What type of products does TRYON offer?",
      answer: "We offer high-quality, custom-printed T-shirts made using premium fabrics and long-lasting prints."
    },
    {
      id: 2,
      question: "How long does delivery take?",
      answer: "Orders are delivered within 7–15 business days after dispatch. Delivery time may vary depending on location and logistics conditions."
    },
    {
      id: 3,
      question: "Do you offer Cash on Delivery (COD)?",
      answer: "Yes! We offer both Prepaid and Cash on Delivery (COD) payment options. Additional COD charges may apply."
    },
    {
      id: 4,
      question: "How do I track my order?",
      answer: "Once your order is shipped, you'll receive a tracking link via Email/SMS/WhatsApp. You can follow the link to check your delivery status anytime."
    },
    {
      id: 5,
      question: "Can I change or cancel my order?",
      answer: "You can request changes or cancellations within 24 hours of placing the order. After that, the order enters production and cannot be modified."
    },
    {
      id: 6,
      question: "What is your return & refund policy?",
      answer: "Since each product is custom-made:\n• Returns are only accepted for wrong, damaged, or defective products.\n• Raise a request within 48 hours of delivery with unboxing proof.\n• Approved cases will receive a replacement or refund as per Refund Policy."
    },
    {
      id: 7,
      question: "What if I ordered the wrong size?",
      answer: "We currently do not accept returns for incorrect size selection. We recommend checking our Size Chart before ordering or contacting us for help."
    },
    {
      id: 8,
      question: "What if I miss the delivery?",
      answer: "The courier will attempt delivery 2–3 times. If unsuccessful, the package may return to us and re-shipping charges may apply."
    },
    {
      id: 9,
      question: "Are the printed designs durable?",
      answer: "Yes! We use high-quality printing methods designed to last long with proper care. We include washing instructions with every order for best longevity."
    },
    {
      id: 10,
      question: "How can I contact customer support?",
      answer: "You can reach us at:\n📧 Email: tyon.wear02@gmail.com\n📞 Phone: +91 9265490049\nSupport is available Mon–Sat, 10 AM – 6 PM."
    }
  ];

  const toggleQuestion = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1>Frequently Asked Questions (FAQs)</h1>
          <p>Got questions? We've got answers!</p>
        </div>

        <div className="faq-list">
          {faqs.map((faq) => (
            <div 
              key={faq.id} 
              className={`faq-item ${openQuestion === faq.id ? 'active' : ''}`}
              onClick={() => toggleQuestion(faq.id)}
            >
              <div className="faq-question">
                <span className="question-number">{faq.id}⃣</span>
                <h3>{faq.question}</h3>
                <span className="toggle-icon">
                  {openQuestion === faq.id ? '−' : '+'}
                </span>
              </div>
              {openQuestion === faq.id && (
                <div className="faq-answer">
                  {faq.answer.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="faq-footer">
          <h2>Still have questions?</h2>
          <p>Feel free to reach out to our support team!</p>
          <div className="contact-buttons">
            <a href="mailto:tyon.wear02@gmail.com" className="contact-btn email">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              Email Us
            </a>
            <a href="tel:+919265490049" className="contact-btn phone">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/>
              </svg>
              Call Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
